import git from "../assets/png/git.png";
import sql from "../assets/png/sql.png";
import comp from "../assets/png/comp.png";
import open from "../assets/png/open.jpeg";

export const achievementData = {
    bio: {
        en: "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn. - Alvin Toffler",
        fr: "Les illettrés du 21e siècle ne seront pas ceux qui ne savent pas lire et écrire, mais ceux qui ne peuvent pas apprendre, désapprendre et réapprendre. - Alvin Toffler"
    },
    achievements: [
        {
            id: 1,
            title: {
                en: "Conference Cellule",
                fr: "Conférence Cellule"
            },
            details: {
                en: "Open Source Days v13",
                fr: "Journées Open Source v13"
            },
            date: "Nov, 2024",
            field: {
                en: "Organization",
                fr: "Organisation"
            },
            image: open
        },
        {
            id: 2,
            title: {
                en: "Competition",
                fr: "Compétition"
            },
            details: {
                en: "Open Source Days v12",
                fr: "Journées Open Source v12"
            },
            date: "Apr, 2024",
            field: {
                en: "Problem Solving",
                fr: "Résolution de problèmes"
            },
            image: comp
        },
        {
            id: 3,
            title: {
                en: "SQL",
                fr: "SQL"
            },
            details: {
                en: "365datascience",
                fr: "365datascience"
            },
            date: "Nov, 2024",
            field: {
                en: "Database",
                fr: "Base de données"
            },
            image: sql
        },
        {
            id: 4,
            title: {
                en: "Git and Github",
                fr: "Git et Github"
            },
            details: {
                en: "365datascience",
                fr: "365datascience"
            },
            date: "Nov, 2024",
            field: {
                en: "Version Control",
                fr: "Gestion de version"
            },
            image: git
        }
    ]
};
